import { z } from "zod";
import { zBool, zObj, zOptional, zStr } from "./zodWrapper.js";
export var LoginMethod;
(function (LoginMethod) {
    LoginMethod["GOOGLE"] = "google";
    LoginMethod["MICROSOFT"] = "microsoft";
})(LoginMethod || (LoginMethod = {}));
export const LoginMethodEnum = z.nativeEnum(LoginMethod);
export const SessionValidityStatus = zObj({
    email: zStr(),
    isAuthenticated: zBool(),
    name: zStr(),
    profilePicture: zOptional(zStr()),
});
export const LoginArgs = zObj({ token: zStr(), method: LoginMethodEnum });
export const LoginInfo = zObj({ provider: LoginMethodEnum });
//# sourceMappingURL=auth.js.map